<!-- Translated: yes -->
<template>
  <div class="modalo" :style="'z-index:' + zIndex + ';'">
    <span class="close" @click="close" v-if="showClose">
      <icon name="times-white" :scale="5"></icon>
    </span>

    <Back :text="closeText" :clicked="close" v-if="showClose" />

    <div class="outer" @click="closeFromOuterClick">
      <div :class="{ 'container': true, 'wide': wide, 'fullwide': fullwide }" :style="{'max-width': width}">
        <div :class="'content ' + this.setClass" id="modal-container-content" :style="{'min-width': minWidth, 'width': normalWidth, 'max-width': width}">
          <header>
            <slot name="header"></slot>
          </header>

          <main>
            <slot></slot>
          </main>

          <footer>
            <slot name="footer"></slot>
          </footer>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Back from '@/components/components/Back';

export default {
  props: {
    wide: {
      default: false,
    },
    fullwide: {
      default: false,
    },
    width: {
      default: '100%',
    },
    setClass: {
      default: '',
    },
    showClose: {
      default: true,
    },
    closeText: {
      default: '',
    },
    minWidth: {
      default: '100px',
    },
    normalWidth: {
      default: 'auto',
    },
    zIndex: {
      default: 99999,
    },
    clickOutside: {
      default: true,
    },
  },
  components: {
    Back,
  },
  methods: {
    close() {
      this.$emit('close', false);
    },
    closeFromOuterClick(e) {
      if (this.clickOutside) {
        const content = document.getElementById('modal-container-content');
        if (e.target !== content && (content && !content.contains(e.target))) {
          e.stopPropagation();
          this.close();
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.modalo
  position fixed
  top 0
  left 0
  width 100vw
  height 100%
  background-color black-70
  overflow auto
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll
  z-index 99999

.outer
  width 100vw
  height 100%
  box-sizing border-box
  padding 30px space-2 0
  +max-mobile()
    padding 0
    min-height 100%

containerWidth()
  width 100vw
  max-width 100vw !important
  padding-bottom 0
  min-height 100%
  padding-bottom: 120px
  padding-left 0
  padding-right 0
  padding-top 0

.container
  max-width container-width
  min-height 100%
  margin-right auto
  margin-left auto
  padding-bottom space-2
  box-sizing border-box
  display flex
  align-items baseline
  justify-content center


  &.wide
    max-width wide-container-width
    padding 20px 60px
    +max-mobile()
      containerWidth()
      padding-bottom 0;
  &.fullwide
    padding 20px 0
    +max-mobile()
      containerWidth()
      padding-bottom 0;
  +max-mobile()
    containerWidth()
    padding-bottom 0;

.content
  background-color white
  border-radius 3px
  box-shadow 0 0 15px 0 rgba(0, 0, 0, 0.08)
  max-width 100%
  min-width 310px
  padding 30px 45px 30px 45px
  position: relative;

  +max-mobile()
    padding 25px padding-mobile 25px padding-mobile
    width 100vw !important
    max-width 100vw !important
    padding-bottom 90px
    border-radius: 0
    min-height calc(100vh - 50px)
    box-shadow 0 0 0px 0 rgba(0, 0, 0, 0)
  &.no-padding
    padding 0
    +max-mobile()
      padding-bottom 50px
  &.no-padding-ever
    padding 0
  +max-mobile()
    &.no-padding-mobile
      padding 0
      padding-bottom 50px
  .container.wide &
    width 100%
    padding space-2 space-2 2.5rem space-2
    &.no-padding
      padding 0
    +max-mobile()
      &.no-padding-mobile
        padding 0
        padding-bottom 50px


.close
  position fixed
  top space-3
  right space-3
  color white
  cursor pointer
  z-index 10
  +max-mobile()
    display none

.back
  display none !important
  +max-mobile()
    top 0
    right auto
    left 0
    width 100vw
    height 50px
    background-color #ecf5f8
    padding 15px 20px
    text-align left
    display block !important
  .icon--times-white
    +max-mobile()
      display none
  .text
    display none
    color deep-sea-blue
    uppercase()
    font-weight 700
    +max-mobile()
      display block
      font-size: 14px!important

</style>



// WEBPACK FOOTER //
// Modal.vue?1346a4be